// Shared display-label helpers for warranty metadata used across the
// transfers wizard. Keep pricing/fee logic out
// of here - this module is presentation-only.

/**
 * Maps a raw `warranty_type` slug (e.g. `manufacturer_standard`,
 * `extended_10yr`, `retailer_plus`) to the short label we show in the
 * UI. Unknown types fall through unchanged so we don't silently
 * misrepresent them as "Standard".
 */
export function warrantyTypeLabel(type: string): string {
  const t = type.toLowerCase()
  if (t.includes('extended')) return 'Extended'
  if (t.includes('manufacturer')) return 'Standard'
  if (t.includes('retailer')) return 'Standard'
  return type
}
